import '../css/app.css';

import { createInertiaApp } from '@inertiajs/react';
import { createRoot } from 'react-dom/client';

// Initialize Laravel Echo for real-time WebSocket communication
import './lib/echo';

// Resolve page components from the Pages directory
const pages = import.meta.glob('./Pages/**/*.tsx', { eager: true });

createInertiaApp({
    // Set the page title with app name suffix
    title: (title) => (title ? `${title} - Sellune` : 'Sellune'),

    // Resolve page component by name
    resolve: (name) => {
        const page = pages[`./Pages/${name}.tsx`];
        if (!page) {
            throw new Error(`Page not found: ${name}`);
        }
        return page;
    },

    // Setup the React app
    setup({ el, App, props }) {
        createRoot(el).render(<App {...props} />);
    },

    // Show loading indicator during page transitions
    progress: {
        color: '#4B5563',
    },
});

